import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { of, switchMap } from 'rxjs';
import { TenantFeatures, awaitTenantFeatures, isFeatureEnabled } from '../models/featureSettings';
import { PermissionsService } from '../services/permission.service';
import { authenticateAndSetTenant } from '../shared/services/tenant-route-context';
import { TenantSessionState } from '../store/state/tenant-session.state';

// Deep links land here cold: the tenant switch clears features and app.component refetches them.
const FEATURE_RESOLVE_TIMEOUT_MS = 15_000;

export const canActivateThirdPartyApp: CanActivateFn = (route, state) => {
    const permissions = inject(PermissionsService);
    const store = inject(Store);

    return authenticateAndSetTenant(route, state).pipe(
        switchMap(authenticated => {
            if (!authenticated) {
                return of(false);
            }
            return awaitTenantFeatures(
                store.select(TenantSessionState.getTenantFeatures), FEATURE_RESOLVE_TIMEOUT_MS).pipe(
                switchMap(features => isFeatureEnabled(features, route.data['feature'] as TenantFeatures)
                    ? of(true)
                    : permissions.navigateToLanding()));
        }));
};
